var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card mortgage", attrs: { id: "actions-pane-container" } },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "nav-tabs-wrapper bb-0 mt-4 mt-xl-0" },
          [
            _c("scrollable-container", [
              _c(
                "ul",
                { staticClass: "nav nav-tabs" },
                _vm._l(_vm.tabs, function (ref) {
                  var name = ref.name
                  var label = ref.label
                  return _c(
                    "li",
                    {
                      key: name,
                      staticClass: "nav-item",
                      class: _vm.activeItem(name) ? "nav-item-active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.setCurrentTab(name)
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-link grey-text text-darken-3 clickable",
                        },
                        [_vm._v(_vm._s(label))]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.collapsed
          ? _c(
              "div",
              {
                staticClass: "clickable py-1 px-2 text-light-gray close-action",
                on: { click: _vm.toggleCollapse },
              },
              [_c("icon", { attrs: { name: "times", "aria-hidden": "true" } })],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "action-pane-tabs-container" } },
        [
          !_vm.collapsed
            ? _c(
                "div",
                {
                  staticClass:
                    "clickable pre-selected-area mt-2 text-light-gray",
                  on: { click: _vm.toggleCollapse },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("global.actions.clickHereTo", {
                          item: _vm.getCollapseText(),
                        })
                      ) +
                      "...\n    "
                  ),
                ]
              )
            : _c("referrer-" + _vm.currentTab + "-tab", {
                key: _vm.currentTab,
                tag: "component",
                attrs: {
                  "current-tab": _vm.currentTab,
                  referrer: _vm.referrer,
                  "referrer-id": _vm.referrerId,
                },
                on: { submit: _vm.handleSubmit },
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }